const styles = {
    loadingContainer: {
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mainContainer: {
        fontFamily: 'Verlag A, Verlag B',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        lignContent: 'center',
        alignItems: 'center',
        maxWidth: '100vw',
        overflowX: 'hidden',
        width: '100%',
        height: '100%',
        fontWeight: '300',
        fontSize: '18px',
    },
    formCard: {
        maxWidth: '600px',
        width: '100%',
        height: '100%',
        padding: '25px 10px 0 10px',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
        '@media (max-width: 400px)': {
            margin: '0',
            width: '100%',
            height: '100%',
            padding: '25px 0',
            borderRadius: '5px',
        },
    },
    gold: {
        '@media (max-width: 400px)': {
            backgroundColor: '#EAD19D',
        },
    },
    titleText: {
        fontSize: '1.85rem',
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: '20px',
        '@media (max-width: 600px)': {
            // fontSize: '1.5rem'
        },
    },
    formContainer: {
        minWidth: '280px'
    },
    linkContainer: {
        padding: '15px',
        fontSize: '1.65rem',
        margin: '0 0 10px 0',
        fontWeight: '300',
        borderRadius: '50px',
        WebkitTransition: '.5s all',
        transition: '.5s all',
        whiteSpace: 'nowrap',
        border: 'none',
        textTransform: 'none',
        width: '500px',
        maxWidth: '85vw',
        outline: 'none',
        '@media (max-width: 600px)': {
            width: '85vw'
        },
    },
    americanButton0: { color: 'white', backgroundColor: '#2670c5' },
    americanButton1: { color: 'white', backgroundColor: '#64c3e4' },
    americanButton2: { color: 'white', backgroundColor: '#f80000' },
    americanButton3: { color: 'white', backgroundColor: '#092c7e' },
    americanButton4: { color: 'white', backgroundColor: '#2670c5' },
    americanButton5: { color: 'white', backgroundColor: '#f80000' },
    americanButton6: { color: 'white', backgroundColor: '#64c3e4' },
    americanButton7: { color: 'white', backgroundColor: '#092c7e' },
    americanButton8: { color: 'white', backgroundColor: '#f80000' },
    americanButton9: { color: 'white', backgroundColor: '#2670c5' },
    americanButton10: { color: 'white', backgroundColor: '#64c3e4' },
    superButton0: { color: 'white', backgroundColor: '#1E7C15' },
    superButton1: { color: 'white', backgroundColor: '#6DD435' },
    superButton2: { color: 'white', backgroundColor: '#69017E' },
    superButton3: { color: 'white', backgroundColor: '#F4CB2F' },
    superButton4: { color: 'white', backgroundColor: '#1E7C15' },
    superButton5: { color: 'white', backgroundColor: '#69017E' },
    superButton6: { color: 'white', backgroundColor: '#6DD435' },
    superButton7: { color: 'white', backgroundColor: '#F4CB2F' },
    superButton8: { color: 'white', backgroundColor: '#69017E' },
    superButton9: { color: 'white', backgroundColor: '#1E7C15' },
    superButton10: { color: 'white', backgroundColor: '#6DD435' },
    dreamButton0: { color: '#021416', backgroundColor: '#8AE4FC' },
    dreamButton1: { color: 'white', backgroundColor: '#185A5D' },
    dreamButton2: { color: '#021416', backgroundColor: '#92FE9C' },
    dreamButton3: { color: '#021416', backgroundColor: '#FDF590' },
    dreamButton4: { color: '#021416', backgroundColor: '#8AE4FC' },
    dreamButton5: { color: '#021416', backgroundColor: '#92FE9C' },
    dreamButton6: { color: 'white', backgroundColor: '#185A5D' },
    dreamButton7: { color: '#021416', backgroundColor: '#FDF590' },
    dreamButton8: { color: '#021416', backgroundColor: '#92FE9C' },
    dreamButton9: { color: '#021416', backgroundColor: '#8AE4FC' },
    dreamButton10: { color: 'white', backgroundColor: '#185A5D' },
    goldButton0: { color: '#021416', backgroundColor: '#8AE4FC' },
    goldButton1: { color: 'white', backgroundColor: '#185A5D' },
    goldButton2: { color: '#021416', backgroundColor: '#92FE9C' },
    goldButton3: { color: '#021416', backgroundColor: '#FDF590' },
    goldButton4: { color: '#021416', backgroundColor: '#8AE4FC' },
    goldButton5: { color: '#021416', backgroundColor: '#92FE9C' },
    goldButton6: { color: 'white', backgroundColor: '#185A5D' },
    goldButton7: { color: '#021416', backgroundColor: '#FDF590' },
    goldButton8: { color: '#021416', backgroundColor: '#92FE9C' },
    goldButton9: { color: '#021416', backgroundColor: '#8AE4FC' },
    goldButton10: { color: 'white', backgroundColor: '#185A5D' },
    hover: {
        cursor: 'pointer',
        WebkitBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
        MozBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
        boxShadow: '5px 40px -10px rgba(0,0,0,0.57)',
        transition: 'all 0.7s ease',
        fontSize: '1.6rem',
    },
    nextText: {
        fontSize: '1.3rem',
        fontWeight: 'bold',
        textDecoration: 'underline'
    }
};

export default styles;